import type { RelatedPost } from '@/types/app';
import { Pagination } from '@/components/atoms';
import { PostCard } from '../PostCard/PostCard';
import './RelatedPosts.scss';

interface RelatedPostsProps {
  posts: RelatedPost[];
  title?: string;
  currentPage?: number;
  totalPages?: number;
  basePath?: string;
}

export function RelatedPosts({
  posts,
  title = 'Actualités et bons plans',
  currentPage,
  totalPages,
  basePath,
}: RelatedPostsProps) {
  if (!posts.length) return null;

  return (
    <section className="related-posts">
      <h2 className="related-posts__title">{title}</h2>
      <div className="post-card-grid">
        {posts.map((relatedPost) => (
          <PostCard key={relatedPost.id} post={relatedPost} />
        ))}
      </div>
      {currentPage && totalPages && basePath && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          basePath={basePath}
        />
      )}
    </section>
  );
}
